/** Pantallas de entrenador — español */
export const TRAINER_SCREENS_ES = {
  'addWorkout.title': 'Nuevo entreno',
  'addWorkout.step.type': 'Tipo',
  'addWorkout.step.typeShort': 'Tipo',
  'addWorkout.step.clients': 'Clientes',
  'addWorkout.step.clientsShort': 'Clientes',
  'addWorkout.step.datetime': 'Fecha y hora',
  'addWorkout.step.timeShort': 'Hora',
  'addWorkout.step.confirm': 'Revisar',
  'addWorkout.step.doneShort': 'Listo',
  'addWorkout.next': 'Siguiente',
  'addWorkout.create': 'Crear',
  'addWorkout.validating': 'Comprobando…',
  'addWorkout.validatingConflicts': 'Buscando conflictos…',
  'addWorkout.creating': 'Creando…',
  'addWorkout.createGroup': 'Crear entreno grupal',
  'addWorkout.createSelf': 'Crear entreno en solitario',
  'addWorkout.createWorkout': 'Crear entreno',
  'addWorkout.successGroup': '¡Entreno grupal creado para {n} clientes!',
  'addWorkout.successSelf': '¡Entreno en solitario creado!',
  'addWorkout.successIndividual': '¡Entreno creado!',
  'addWorkout.step1Title': 'Tipo de entreno',
  'addWorkout.step1Hint': 'Elige qué tipo de sesión vas a programar',
  'addWorkout.typeIndividual': '1:1',
  'addWorkout.typeIndividualDesc': 'Un cliente',
  'addWorkout.typeGroup': 'Grupo',
  'addWorkout.typeGroupDesc': 'De dos a diez clientes',
  'addWorkout.typeSelfDesc': 'Para ti',
  'addWorkout.hintIndividual': 'Elegiste sesión 1:1. Ahora, elige al cliente.',
  'addWorkout.hintGroup':
    'Elegiste sesión grupal. Ahora, elige a los clientes (mínimo 2, máximo 10).',
  'addWorkout.hintSelf': 'Elegiste sesión en solitario. Puedes saltar la elección de cliente.',
  'addWorkout.step2Title': 'Clientes',
  'addWorkout.step2Individual': 'Elige el cliente de esta sesión',
  'addWorkout.step2Group': 'Elige a los clientes del grupo',
  'addWorkout.step2Self': 'En sesión en solitario no hace falta cliente',
  'addWorkout.clientTooltip': 'Empieza a escribir un nombre para buscar en tu lista',
  'addWorkout.clientLabel': 'Cliente *',
  'addWorkout.clientPlaceholder': 'Escribe el nombre del cliente…',
  'addWorkout.clientSearchHint': 'Empieza a escribir para buscar en tu lista',
  'addWorkout.groupTooltip': 'Grupos: de 2 a 10 clientes',
  'addWorkout.groupClientsLabel': 'Clientes del grupo *',
  'addWorkout.groupClientPlaceholder': 'Escribe un nombre para añadir…',
  'addWorkout.groupPickHint': 'Añade entre 2 y 10 clientes para la sesión grupal',
  'addWorkout.groupSelected': 'Seleccionados: {n}/10',
  'addWorkout.selfSectionLabel': 'Entreno en solitario',
  'addWorkout.selfNoClient': 'Solo entrenador, sin cliente',
  'addWorkout.step3Title': 'Fecha y hora',
  'addWorkout.step3Hint': 'Indica cuándo es el entreno',
  'addWorkout.dateTooltip': 'Elige la fecha del entreno',
  'addWorkout.dateLabel': 'Fecha *',
  'addWorkout.pickDate': 'Elige una fecha',
  'addWorkout.pickDateAria': 'Elige una fecha',
  'addWorkout.timeBlockTooltip': 'Hora de inicio y fin. Arrastra los controles para ajustar.',
  'addWorkout.workoutTimeLabel': 'Horario del entreno *',
  'addWorkout.startTime': 'Inicio',
  'addWorkout.endTime': 'Fin',
  'addWorkout.endTimePlaceholder': 'Auto +1 h',
  'addWorkout.endTimeHint': 'Por defecto, una hora después del inicio',
  'addWorkout.recurrenceTooltip': 'Con qué frecuencia se repite esta sesión',
  'addWorkout.recurrenceLabel': 'Repetir',
  'addWorkout.recurrencePlaceholder': 'Patrón de repetición',
  'addWorkout.recurrenceNone': 'No se repite',
  'addWorkout.recurrenceWeekly': 'Cada semana',
  'addWorkout.weekdaysTooltip': 'Elige los días en que se repite',
  'addWorkout.weekdaysLabel': 'Días de la semana',
  'addWorkout.weekdaysHint': 'Marca los días en los que se repite el entreno',
  'addWorkout.step4Title': 'Revisar',
  'addWorkout.step4Hint': 'Comprueba los datos y añade una nota si quieres',
  'addWorkout.detailsTitle': 'Detalles',
  'addWorkout.fieldType': 'Tipo:',
  'addWorkout.fieldClient': 'Cliente:',
  'addWorkout.fieldClients': 'Clientes:',
  'addWorkout.fieldDate': 'Fecha:',
  'addWorkout.fieldTime': 'Hora:',
  'addWorkout.fieldRecurrence': 'Repetición:',
  'addWorkout.notSelected': 'Sin elegir',
  'addWorkout.dateNotSelected': 'Sin elegir',
  'addWorkout.clientsCount': '{n} clientes',
  'addWorkout.commentTooltip': 'Nota opcional para este entreno',
  'addWorkout.commentLabel': 'Nota',
  'addWorkout.commentPlaceholder': 'Escribe un comentario',
  'addWorkout.errMaxGroup': 'Un entreno grupal puede incluir como mucho 10 clientes',
  'addWorkout.errRequired': 'Completa todos los campos obligatorios',
  'addWorkout.errGroupPickOne': 'Selecciona al menos un cliente para el grupo',
  'addWorkout.errGroupMin2':
    'Los entrenos grupales necesitan al menos dos clientes. Cambia a 1:1 o añade más clientes.',
  'addWorkout.errDateTime': 'Indica fecha y hora del entreno',
  'addWorkout.errTimeConflict': 'No se pudo crear el entreno: conflicto de horario',
  'addWorkout.errCreate': 'No se pudo crear el entreno',
  'addWorkout.errAlreadyCreated': 'El entreno ya había sido creado',
  'addWorkout.errRecurringConflict':
    'Conflicto al crear el entreno repetido el {date} a las {time}. Ocupado: {clients}',
  'addWorkout.errMerge': 'No se pudieron fusionar los entrenos',
  'addWorkout.conflictDialogTitle': 'Ya hay otro entreno a esta hora',
  'addWorkout.conflictDialogAsk': '¿Crearlo igualmente?',
  'addWorkout.conflictingHeading': 'Entrenos en conflicto:',
  'addWorkout.conflictClientFallback': 'Cliente',
  'addWorkout.conflictNo': 'No',
  'addWorkout.conflictYes': 'Crear igualmente',
  'addWorkout.conflictWhen': '{date}, {time}',

  'mergeWorkout.title': '¿Fusionar entrenos?',
  'mergeWorkout.lead': 'Estos clientes ya tienen entreno a esta hora:',
  'mergeWorkout.question': '¿Unirlos en un entreno grupal el {date} a las {time}?',
  'mergeWorkout.fallbackDate': 'la fecha elegida',
  'mergeWorkout.fallbackTime': 'la hora elegida',
  'mergeWorkout.unknownClients': 'clientes desconocidos',
  'mergeWorkout.merge': 'Fusionar',

  'analytics.errBadFormat': 'Datos del servidor con formato inválido',
  'analytics.errLoad': 'No se pudieron cargar las estadísticas',
  'analytics.loading': 'Cargando estadísticas…',
  'analytics.noData': 'Aún no hay nada que mostrar',
  'analytics.totalRevenue': 'Ingresos totales',
  'analytics.prevMonth': 'Mes anterior',
  'analytics.nextMonth': 'Mes siguiente',
  'analytics.moreCurrencies': 'Más divisas',
  'analytics.newClients': 'Clientes nuevos',
  'analytics.workouts': 'Entrenos',
  'analytics.completed': 'Completados',
  'analytics.awaitingPayment': 'Pendientes de pago',
  'analytics.revenueByMonth': 'Ingresos por mes',
  'analytics.emptyChart': 'Sin datos',
  'analytics.colMonth': 'Mes',
  'analytics.colAmount': 'Importe',
  'analytics.hide': 'Ocultar',
  'analytics.showMore': 'Ver más',
  'analytics.unpaidTitle': 'Pendientes de pago',
  'analytics.unpaidSubtitle': 'Sesiones sin cobrar',
  'analytics.unpaidEmpty': 'No hay sesiones pendientes de pago',
  'analytics.unknownClient': 'Cliente desconocido',
  'analytics.addPayment': 'Añadir pago',
  'analytics.dateNotSet': 'Sin fecha',
  'analytics.timeSuffix': ' a las {time}',
  'analytics.expand': 'Ver más',
  'analytics.collapse': 'Ocultar',
  'analytics.addPaymentTitle': 'Añadir pago',
  'analytics.clientLabel': 'Cliente:',

  'plansScreen.title': 'Planes de entreno',
  'plansScreen.exerciseDictTitle': 'Referencia de ejercicios',
  'plansScreen.addPlan': 'Añadir plan',
  'plansScreen.searchPlaceholder': 'Buscar planes de entreno…',
  'plansScreen.allGroups': 'Todos los grupos musculares',
  'plansScreen.loading': 'Cargando…',
  'plansScreen.empty': 'Aún no hay planes de entreno',
  'plansScreen.addPlanLarge': 'Crear un plan de entreno',
  'plansScreen.noneMatch': 'Ningún plan coincide con los filtros',
  'plansScreen.resetFilters': 'Restablecer filtros',
  'plansScreen.exerciseCount': '{n} ejercicios',
  'plansScreen.noExercisesInPlan': 'Este plan no tiene ejercicios',
  'plansScreen.addExercises': 'Añadir ejercicios',
  'plansScreen.deleteTitle': '¿Eliminar plan?',
  'plansScreen.deleteDesc': '¿Eliminar el plan «{name}»? No se puede deshacer.',
  'plansScreen.setPattern': '{reps} × {weight}',
};
